export default __webpack_public_path__ + "static/media/DriveMobile.cd8e4e8c.svg";